export enum Authority{
    ROLE_ADMIN ="ROLE_ADMIN",
    NOT_USED_CURRENTLY = "not-used-currently"
}